import { render, staticRenderFns } from "./PbxMonitor.vue?vue&type=template&id=f33bcac8&"
import script from "./PbxMonitor.vue?vue&type=script&lang=js&"
export * from "./PbxMonitor.vue?vue&type=script&lang=js&"
import style0 from "./PbxMonitor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports